<template>
  <v-dialog
      v-model="dialog"
      width="800"
      large
  >
    <template v-slot:activator="{ on, attrs }">
      <v-icon
          v-if="item == null"
          v-bind="attrs"
          v-on="on"
      >
        mdi-plus-box
      </v-icon>
      <v-icon
          v-else
          small
          v-bind="attrs"
          v-on="on"
      >
        mdi-pencil-circle
      </v-icon>
    </template>
    <v-card>
      <v-card-title v-if="localItem.calendar_date_user.human_user.id === null">
        New paid/bonus time
      </v-card-title>
      <v-card-title v-else>
        Paid/bonus time for  {{ localItem.calendar_date_user.human_user.user }} ({{ localItem.calendar_date_user.human_user.employee_number }})
      </v-card-title>
      <v-card-text>
        <v-form
            ref="PayedNewForm"
            v-model="form"
        >
          <v-row>
            <v-col cols="12" v-if="item === null">
              <v-autocomplete
                  :rules="[rules.required]"
                  v-model="localItem.calendar_date_user.human_user.id"
                  :items="userList"
                  label="User"
                  clearable
                  hint="Enter users name or employee number"
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <v-text-field
                  :rules="[rules.required]"
                  label="Date"
                  type="date"
                  v-model="localItem.calendar_date_user.calendar_date.dt"
                  :value="localItem.calendar_date_user.calendar_date.dt"
                  :max="current_datetime"
                  :disabled="!(localItem === null || localItem.id == null)"
              >
              </v-text-field>
            </v-col>
            <v-col cols="3">
              <v-text-field
                  v-if="extra_hours === '' || extra_hours === null || extra_hours == 0"
                  label="Paid"
                  type="number"
                  v-model="paid"
              >
              </v-text-field>
            </v-col>
            <v-col cols="3">
              <v-text-field
                  v-if="paid === '' || paid === null || paid == 0"
                  label="Extra hours"
                  type="number"
                  v-model="extra_hours"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-textarea
                label="Comment"
                v-model="localItem.comment"
                outlined
            >
            </v-textarea>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn
            @click="dialog = false"
        >
          Cancel
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
            v-if="item == null"
            :disabled="!form"
            @click="onSave"
        >
          Add
        </v-btn>
        <v-btn
            v-else
            :disabled="!form"
            @click="onSave"
        >
          Save
        </v-btn>
      </v-card-actions>

    </v-card>
  </v-dialog>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {mapFields} from "vuex-map-fields";
import Moment from "moment";
import {v4 as uuidv4} from "uuid";

export default {
  name: 'PayedNewEditDialog',
  props: {
    item: {default: null},
    length: {default: null},
    disabled: {default: false}
  },

  computed: {
    ...mapGetters('HRPayed', ['getColumns',]),
    ...mapFields('HRPayed', ['message_error', 'options', 'totalRecords', 'options.page', 'onlyFailedView', 'briefView', 'itemList',
      'loading', 'deleteLoading', 'updateLoading', 'restoring', 'selectedItemList', 'searchTermFile', 'searchTerm',
      'isAlive', 'action_loading', 'filters', 'local_phrase', 'lang',]),
    ...mapFields('HumanUser', {itemListHuman: 'itemList'},),

    userList() {
      let user_list = []
      this.itemListHuman.forEach(row => user_list.push({
        text: row.user + '(' + row.employee_number + ')',
        value: row.id
      }))
      return user_list
    },
    current_datetime() {
      const dt =  Moment().format('YYYY-MM-DD')
      // console.log('current_datetime', dt)
      return dt
    },
  },

  methods: {
    ...mapActions('HRPayed', ['fetchSaveItemField']),


    onSave() {
      console.log('onSave', this.localItem)
      let fields_dict = {}
      fields_dict['calendar_date_user'] = this.localItem.calendar_date_user
      fields_dict['payed'] = 0
      if (!!this.paid)
        fields_dict['payed'] = this.paid
      if (!!this.extra_hours)
        fields_dict['payed'] = -this.extra_hours
      fields_dict['comment'] = this.localItem.comment
      if (this.localItem.id == null)
        fields_dict['uid'] = uuidv4()
      else
        fields_dict['uid'] = this.localItem.uid
      this.fetchSaveItemField({
        itemId: this.localItem.id,
        fields_dict: fields_dict,
        dto_model: {to_consumer: 'PayedEventDTO', from_consumer: 'PayedEventDTO'}
      })
      this.dialog = false
      this.$refs['PayedNewForm'].resetValidation()
      if (this.localItem === null || this.localItem.id == null)
        this.localItem = {
          id: null,
          uid: uuidv4(),
          calendar_date_user: {
            calendar_date: {dt: null},
            human_user: {id: null},
          },
          payed: 0,
          comment: null,
        }
    },
  },

  mounted() {
    // console.log('mounted', this.item)
    if (this.item != null) {
      this.localItem = this.item
      if (this.localItem.payed >= 0) {
        this.paid = this.localItem.payed
        this.extra_hours = null
      }
      else {
        this.paid = null
        this.extra_hours = - this.localItem.payed
      }
    }
  },

  data() {
    return {
      dialog: false,
      itemSaved: null,
      form: false,
      localItem: {
          id: null,
          calendar_date_user: {
            calendar_date: {dt: null},
            human_user: {id: null},
          },
          payed: 0,
          comment: null,
        },
      paid: null,
      extra_hours: null,
      rules: {
        min: len => v => (v || '').length >= len || `Invalid character length, required great or equal ${len}`,
        max: len => v => (v || '').length <= len || `Invalid character length, required low or equal ${len}`,
        required: v => !!v || 'This field is required',
      },
    }
  }
}

</script>


<style scoped lang="scss">
.no-spin input[type='number'] {
  -moz-appearance: textfield;
}

.no-spin input::-webkit-outer-spin-button,
.no-spin input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

</style>